<template>
    <v-container class="mandate">
      
        <v-form ref="form" lazy-validation @submit.prevent="false">
            <v-card class="pa-4 mb-4">
                <v-card-title class="pb-0">
                    <h2>1. Informationen zum Maklervertrag</h2>
                </v-card-title>
                <v-card-text>
                    <div>
                        <p>Sie geben uns den Auftrag Ihre genannten Verträge zu verwalten, zu digitalisieren und zukünftig zu aktualisieren (siehe unten - Finanzchecks verwaltete Verträge). Keine Sorge, die Post erhalten Sie weiterhin wie gewohnt.</p>
                        <p>Finanzchecks, als unabhängiger Versicherungsmakler, vertritt die Interessen von Ihnen und nicht der Versicherungsgesellschaften. Ähnlich wie ein Rechtsanwalt oder Steuerberater, sind wir verpflichtet im Auftrag von Ihnen zu handeln.</p>
                    </div>
                    <div>
                        <v-expansion-panel expand>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h3 class="fcred--text"><v-icon left>emoji_events</v-icon> Was sind Ihre Vorteile?</h3>
                                </template>
                                <v-card>
                                    <v-list three-line expand>
                                        <v-list-tile v-for="(item,i) in info_texts" :key="i">
                                            <v-list-tile-action>
                                                <v-icon color="green">check</v-icon>
                                            </v-list-tile-action>
                                            <v-card flat>
                                                <v-card-title>
                                                    <h4 class="v-list__tile__title">{{ item.title }}</h4>
                                                    <p class="v-list__tile__sub-title" v-html="item.desc" />
                                                </v-card-title>
                                            </v-card>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </div>
                    <div class="morequestions-box">
                        <h4>Sie haben noch Fragen?</h4>
                        <p>Kontaktieren Sie uns gern über den <router-link to="/chat/system" title="Chat öffnen">VAPP-Chat <v-icon>open_in_new</v-icon></router-link> oder persönlich unter der Telefonnummer: <a href="tel:+493030345679">030 / 30 34567 9</a> (Mo.-Fr. 8 - 19 Uhr).</p>
                    </div>
                </v-card-text>
            </v-card>

            <v-card class="pa-4 mb-4">
                <v-card-title class="pb-0">
                    <h2>2. Auftragserteilung</h2>
                </v-card-title>
                <v-card-text>
                    <div>
                        <p>Welche Versicherungsverträge sollen dem Maklervertrag (alle VAPP-Vorteile) hinzugefügt werden oder welche Verträge möchten Sie selbst verwalten (keine Aktualisierung)?</p>
                    </div>
                    <v-layout row wrap>
                        <v-flex xs12 md6 px-2>
                            <v-list two-line subheader>
                                <v-subheader>Finanzchecks verwaltete Verträge &nbsp; <small>(Aktualisierung)</small></v-subheader>
                                <v-divider></v-divider>
                                <v-list-tile v-for="item in contracts_is_mandate__true" :key="item.id" avatar>
                                    <v-list-tile-avatar>
                                        <img v-if="item.productpartner.logo_url" :src="item.productpartner.logo_url" alt="" class="img-fluid" />
                                        <v-icon v-else>{{ item.product.icon }}</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ item.kind ? item.kind : item.product.name }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ item.vertragsnummer ? 'Vertragsnummer: '+item.vertragsnummer : '' }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action v-if="item.origin=='vapp'" @click="setContractHasMandateStatus(item.id, 0)">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon ripple v-on="on">
                                                    <v-icon v-if="isMobile" color="primary">arrow_downward</v-icon>
                                                    <v-icon v-else color="primary">arrow_forward</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Ab sofort wieder selbst verwalten</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                            <div class="text-xs-center hidden-md-and-up" style="margin-inline: -15px;">
                                <v-btn to="/contract/add/" flat class="py-2 fcred--text"><v-icon color="primary" left>add</v-icon> <span class="hide-babyphone">Weitere&nbsp;</span> Versicherung hinzufügen</v-btn>
                            </div>
                        </v-flex>
                        <v-flex xs12 md6 px-2>
                            <v-list two-line subheader>
                                <v-subheader>Selbst verwaltete Verträge &nbsp; <small>(keine Aktualisierung)</small></v-subheader>
                                <v-divider></v-divider>
                                <v-list-tile v-for="item in contracts_is_mandate__false" :key="item.id" avatar>
                                    <v-list-tile-action v-if="item.product.type==='health'">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon ripple v-on="on">
                                                    <v-icon color="grey lighten-1">info</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Die Krankenkassen sind aktuell technisch nicht in der Lage, Daten zu übergeben - daher können wir diese für Sie leider nicht verwalten :/.</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else-if="item.productpartner.is_transferpositive=='0'">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon ripple v-on="on">
                                                    <v-icon color="grey lighten-1">info</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Der Versicherer ist aktuell technisch nicht in der Lage, Daten zu übergeben - daher können wir diesen Vertrag für Sie leider nicht verwalten :/.</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else @click="setContractHasMandateStatus(item.id, 1)">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon ripple v-on="on">
                                                    <v-icon v-if="isMobile" color="primary">arrow_upward</v-icon>
                                                    <v-icon v-else color="primary">arrow_back</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Ab sofort von VAPP verwalten lassen</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ item.kind ? item.kind : item.product.name }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ item.vertragsnummer ? 'Vertragsnummer: '+item.vertragsnummer : '' }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-avatar>
                                        <img v-if="item.productpartner.logo_url" :src="item.productpartner.logo_url" alt="" class="img-fluid" />
                                        <v-icon v-else>{{ item.product.icon }}</v-icon>
                                    </v-list-tile-avatar>
                                </v-list-tile>
                            </v-list>
                            <div class="text-xs-center hidden-md-and-up" style="margin-inline: -15px;">
                                <v-btn to="/contract/add/" flat class="py-2 fcred--text"><v-icon color="primary" left>add</v-icon> <span class="hide-babyphone">Weitere&nbsp;</span> Versicherung hinzufügen</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center class="hidden-sm-and-down">
                        <v-btn to="/contract/add/" flat class="py-2 fcred--text"><v-icon color="primary" left>add</v-icon> <span class="hide-babyphone">Weitere&nbsp;</span> Versicherung hinzufügen</v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card class="pa-4 mb-4">
                <v-card-title class="pb-0">
                    <h2>3. Einwilligung</h2>
                </v-card-title>
                <v-card-text>
                    <div v-if="!$store.state.mandate.url">
                        <p>Ich stimme dem Maklervertrag zu, dass oben genannte - Finanzchecks verwaltete Verträge - einholen darf und ab sofort Servicepartner ist. Sie können auch nach Ihrer Einwilligung jederzeit entscheiden, welche Verträge wie verwaltet werden sollen.</p>
                        <p v-if="isMobile">Bitte <b>unterschreiben</b> Sie im folgenden Feld mit Ihrem <b>Finger</b> oder einem <b>Eingabestift</b> den <b>Maklervertrag</b>.</p>
                        <p v-else>Bitte <b>unterschreiben</b> Sie im folgenden Feld mit Ihrer <b>Maus</b> den <b>Maklervertrag</b>. Indem Sie die linke Maustaste gedrückt halten, zeichnen Sie im Feld. Feherhafte Eingaben können Sie mit dem Button "zurücksetzen", rechts unter dem Eingabefeld, wieder entfernen.</p>
                        <vueSignature ref="signature_val" :sigOption="signature_option" :w="'100%'" :h="'200px'" class="signature-box"></vueSignature>
                        <!-- <vueSignature ref="signature" :sigOption="option" :w="'800px'" :h="'400px'" :disabled="disabled" :defaultUrl="dataUrl"></vueSignature> -->
                        <v-layout align-space-around justify-space-between row style="height:25px;">
                            <span class="caption grey--text text--darken-1">Unterschrift: {{ this.$store.getters['user/getDisplayName'](true, 'private') }}, am: {{ $moment().format('DD.MM.YYYY').toString() }}</span>
                            <a @click="signature_clear()" class="fcred--text">zurücksetzen</a>
                        </v-layout>
                        <v-alert class="mt-3" :value="true" v-if="show_error" color="error" icon="warning" outline>Bitte unterzeichnen Sie zunächst, bevor Sie fortfahren.</v-alert>
                    </div>
                    <div v-else>
                        <img :src="$store.state.mandate.url" alt="Unterschrift kann derzeit nicht angezeigt werden" class="mb-3" />
                        <span class="caption grey--text text--darken-1 text-xs-center d-block">Unterschrift: {{ this.$store.getters['user/getDisplayName'](true, 'private') }}, vom: {{ $store.state.mandate.published_date }}</span>
                    </div>
                </v-card-text>

                <v-card-actions v-if="!$store.state.mandate.url" class="pt-5">
                    <v-btn flat color="secondary" to="/">Zur Startseite</v-btn>
                    <v-spacer />
                    <v-btn color="grey" dark :loading="loading" target="_blank" :href="mandate_url"><v-icon left>picture_as_pdf</v-icon> Vorschau</v-btn>
                    <v-btn color="black" dark :disabled="(loading)" :loading="loading" @click="setMandate">Maklervertrag versenden</v-btn>
                </v-card-actions>
                <v-card-actions v-else class="py-4">
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn color="black" v-if="number_of_contracts_is_mandate_with_kind_company>0" dark v-on="on" :disabled="(loading)" :loading="loading" target="_blank" :href="`${mandate_url}&type=company`">Maklervertrag Unternehmen <v-icon right>picture_as_pdf</v-icon></v-btn>
                        </template>
                        <span>Aktuellen Maklervertrag für das Unternehmen als PDF aufrufen</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn color="black" v-if="number_of_contracts_is_mandate_with_kind_private>0" dark v-on="on" :disabled="(loading)" :loading="loading" target="_blank" :href="`${mandate_url}&type=private`" style="margin-left:1rem">Maklervertrag Privat <v-icon right>picture_as_pdf</v-icon></v-btn>
                        </template>
                        <span>Aktuellen Maklervertrag für das Privates als PDF aufrufen</span>
                    </v-tooltip>
                </v-card-actions>
            </v-card>
        </v-form>



        <v-dialog v-model="show_success_modal" width="500">
            <v-card class="mx-auto">
                <v-card-title class="title font-weight-regular">Das hat geklappt!</v-card-title>

                <v-card-text class="pt-0">
                    <p>Sie lassen jetzt arbeiten&hellip; VAPP digitalisiert Ihre ausgewählten Versicherungsverträge. Je nach Versicherer kann dies ein bis vier Wochen dauern. Sobald etwas in Ihrer VAPP passiert, werden Sie per Nachricht informiert.</p>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="black" dark @click="finishMandate">Okay</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/analytics';
import vueSignature from "vue-signature"
import { API_URL_BASE, IS_MOBILE } from '@/constants.js'

export default {
    data() {
        return {
            mandate_url: '#!',
            mandate_datetime: '',
            loading:false,
            show_error: false,
            show_success_modal: false,

            signature_option:{
                penColor:"rgb(0, 0, 255)",
                backgroundColor:"rgba(255,255,255,0)"
            },
            info_texts: [
                {
                    title: 'Komplett kostenfrei für Sie',
                    desc: 'VAPP ist für Sie immer kostenfrei. Für den Beratungs- und Betreuungsservice bezahlen uns die Versicherer über die übliche Provision.'
                },
                {
                    title: '1 Login - alle Verträge aktuell',
                    desc: 'Ihre bestehenden Versicherungsverträge befinden sich in einem geschützten Bereich (DSGVO-konform) im Überblick und auf dem neusten Stand. Eine automatische Synchronisierung findet bereits mit über 100 Versicherern statt.'
                },
                {
                    title: 'Ihre Dokumente per Post & zusätzlich bei VAPP',
                    desc: 'Wir informieren Sie, sobald Ihre Versicherungsverträge mit aktuellen Beiträgen, Leistungen und Dokumenten digitalisiert wurden. Keine Sorge, Sie erhalten Ihren Schriftverkehr nach wie vor auch weiterhin direkt vom Versicherer.<br/>Praktisch wenn Sie Ihrem Steuerberater die Unterlagen als PDF senden möchten oder eine Versicherungsbestätigung benötigen und nicht auf die Post warten möchten.'
                },
                {
                    title: '1-Mal Daten ändern, alle Versicherer informiert',
                    desc: 'Sie müssen Ihren Versicherungsordner nicht mehr durchwälzen: Einfach unter "Meine Daten" entsprechende Änderungen anzeigen und diese werden an alle Ihre Versicherungsgesellschaften gesendet: z.B. Firmenname, Adresse, Kontodaten, et cetera.'
                },
                {
                    title: '1 Ansprechpartner',
                    desc: 'Digitalisierung ist gut, ein persönlicher Ansprechpartner noch besser. Wir bieten Ihnen auch im Schadensfall Erfahrung und Unterstützung. Sie haben Fragen zum Vertrag oder wünschen eine Erweiterung? - Wir stehen mit Rat und Tat an Ihrer Seite.'
                },
                {
                    title: '1-Mal im Jahr ein Preis-Leistungscheck',
                    desc: 'VAPP analysiert Ihren Bedarf, erstellt Angebote oder optimiert bestehende Versicherungsverträge. Ein Tarifvergleich erfolgt ausschließlich mit Ihrem Einverständnis.'
                },
                {
                    title: 'Bedarfsanalyse',
                    desc: 'Nutzen Sie unsere kostenfreie Dienstleistung und lassen sich eine individuelle Bedarfsanalyse, aller notwendigen und wichtigen Absicherungen, von einem unserer Versicherungsexperten aufzeigen.'
                }
            ]
        }
    },

    computed: {
        contracts_is_mandate__true(){
            return this.$store.getters['contracts/getAllContracts'].filter(o => o.is_mandate==1 && (o.contract_status_id==1 || o.contract_status_id==6 || o.contract_status_id==11 || o.contract_status_id==9 || o.contract_status_id==4));
        },
        contracts_is_mandate__false(){
            return this.$store.getters['contracts/getAllContracts'].filter(o => o.is_mandate==0 && (o.contract_status_id==1 || o.contract_status_id==6 || o.contract_status_id==11 || o.contract_status_id==9 || o.contract_status_id==4));
        },
        number_of_contracts_is_mandate_with_kind_company(){
            return _.filter(this.contracts_is_mandate__true, ['type', 'company']).length;
        },
        number_of_contracts_is_mandate_with_kind_private(){
            return _.filter(this.contracts_is_mandate__true, ['type', 'private']).length;
        },
        isMobile(){
            return IS_MOBILE();
        },
        signature_isEmpty(){
            if(!this.$refs.signature_val){ return true }
            //console.log(this.$refs.signature_val.isEmpty());
            return this.$refs.signature_val.isEmpty();
        }
    },

    components:{
		vueSignature
	},

    created(){
        this.getMandateUrl();
    },

    methods: {
        signature_clear(){
            this.$refs.signature_val.clear();
        },
        signature_undo(){
            this.$refs.signature_val.undo();
        },

        getMandateUrl(){
            this.$store.dispatch('auth/getAxiosConfig4Api', false).then(config => {
                this.mandate_url = `${API_URL_BASE}f_api/showMandateContract.php?token=${config.headers.Authorization.substr(7)}`;
            });
        },

        setMandate(){
            if(!this.signature_isEmpty){
                let svg = this.$refs.signature_val.save('image/svg+xml');
                if(svg.length>4000){
                    this.$snotify.success('Maklervertrag versendet', 'Erfolg');
                    this.show_success_modal = true;
                    this.$store.dispatch('mandate/setMandate', {signature_svg: this.$refs.signature_val.save('image/svg+xml')} );
                    this.$store.dispatch('chat/addUserChatMessage', {title:'Maklervertrag verschickt', content:'VAPP hat den Maklervertrag erhalten.', type: 'mandate'} );
                    this.$store.dispatch('chat/setTodo', {
                        type: `NEW_MANDATE`,
                        subject: `Neuer Maklervertrag von ${this.$store.getters['user/getDisplayName']()}`,
                        content: `Für den Kunden "${this.$store.getters['user/getDisplayName'](false, 'company')}" (ID: ${this.$store.state.auth.fb.uid}) bitte alle Versicherer kontaktieren für Maklerübertrag.`,
                        is_resubmission: false,
                        add_data: `{"btn1link":"${this.mandate_url}&type=company","btn1text":"Zum Unternehmens-Maklervertrag","btn2link":"${this.mandate_url}&type=private","btn2text":"Zum Privat-Maklervertrag"}`
                    });
                    if(this.$store.getters['user/getUsersCookieConsent']=='all'){
                        firebase.analytics().logEvent('sign_mandate', { success: true });
                    };
                }else{
                    this.$snotify.error('Bitte mit Ihrer Unterschrift signieren');
                    this.signature_clear();
                }
            }else{
                this.$snotify.error('Bitte unterschreiben Sie zunächst');
            }
        },

        finishMandate(){
            this.show_success_modal = false;
            //this.$router.replace({ path: `/` });
        },

        setContractHasMandateStatus(contract_id, is_mandate){
            if(is_mandate===1){
                this.$snotify.success('Wir kümmern uns jetzt bestmöglich um diesen Vertrag', 'Erfolg');
            }else{
                this.$snotify.success('Sie verwalten nun wieder selbst diesen Vertrag', 'Erfolg');
            }
            this.$store.dispatch('contracts/setContractHasMandateStatus', {contract_id, is_mandate});
        }

    }
}
</script>


<style scoped>
    .theme--light.v-subheader{
        color:#000!important;
    }
    canvas{
        border-bottom: 2px solid #000;
        position: relative;
        z-index: 5;
    }
    ::v-deep .signature-box{
        position: relative;
        -webkit-box-shadow: 0px 0px 10px 0px #0000000f;
        -moz-box-shadow: 0px 0px 10px 0px #0000000f;
        box-shadow: 0px 0px 10px 0px #0000000f;
    }
    ::v-deep .signature-box .canvas{
        z-index: 3;
        position: relative;
    }
    ::v-deep .signature-box::before {
        content: "X";
        position: absolute;
        bottom: -5px;
        left: 5px;
        font-size: 3rem;
        font-weight: 300;
        z-index: 2;
    }
    ::v-deep .signature-box::after {
        content: "(hier digital unterschreiben)";
        position: absolute;
        bottom: calc(-5px + 1rem);
        left: calc(5px + 2.5rem);
        font-size: 1.5rem;
        color:#000A;
        font-weight: 300;
        z-index: 2;
    }
    .v-expansion-panel{
        box-shadow: none;
    }
    .morequestions-box{
        padding: 16px 24px 0;
    }
    .v-list--three-line{
        --iconwidth: 4rem;
    }
    .v-list .v-list__tile__sub-title {
        max-height: initial !important;
        margin: 0;
        display: block;
    }
    .v-list .v-list__tile__title {
        font-weight: 400;
        white-space: normal;
        overflow: initial;
        height: auto;
    }
    .v-list--three-line h3.fcred--text{
        font-weight: 400;
    }
    .v-list--three-line .v-card__title{
        padding: .5rem;
    }
    .v-list--three-line .v-list__tile__action{
        padding-left: .6rem;
        width: var(--iconwidth);
    }
    .v-list--three-line .v-card{
        width: calc(100% - var(--iconwidth));
    }
    .v-list--three-line .v-card__title{
        padding: .5rem;
    }

    @media screen and (max-width: 992px) {
        .v-expansion-panel__header>div:not(.v-expansion-panel__header__icon){
            padding-left: 3rem;
        }
        .v-expansion-panel__header>div:not(.v-expansion-panel__header__icon)>.v-icon{
            margin-left: -3rem;
        }
        .morequestions-box{
            padding: 24px 0 0;
        }
        .theme--light.v-subheader{
            flex-direction: column;
            text-align: center;
            height: 5rem;
        }
        .layout.row.wrap>div{
            margin-top: 2rem;
        }
        .layout.row.wrap>div:last-child{
            margin-top: 8rem;
        }
        .layout.row.wrap .theme--light.v-subheader{
            height: 3rem;
        }
        .v-list--three-line .v-list__tile__action{
            min-width: 18px;
        }
    }

    @media screen and (max-width: 576px) {
        .v-list--three-line{
            --iconwidth: 2rem;
        }
        .v-list--three-line .v-list__tile__action{
            padding-left: 0;
            padding-top: .5rem;
        }
    }

    @media screen and (max-width: 340px) {
        .hide-babyphone{
            display: none;
        }
    }
</style>